import {inject, IReactComponent} from 'mobx-react';
import {SessionHistory} from './SessionHistory';

import './styles.scss';

const mapStoresToProps = (stores: Record<string, any>) => {
    const localizationService = stores.inviteStore?.localizationService;
    return {
        ctrl: stores.inviteStore?.inviteFlowManager?.sessionHistoryController,
        translate: localizationService?.translate.bind(localizationService)
    };
};

const SessionHistoryComponent = inject(mapStoresToProps)(SessionHistory) as IReactComponent;

export default SessionHistoryComponent;
